
import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DisableBranchMiniEntity } from '../../../disableBranch/domain/entities/DisableBranchMiniEntity'

export class DisableBranchMiniModel extends DisableBranchMiniEntity {
constructor(dataDto: DisableBranchMiniEntity) {
  super()
  mapEntityProperties<DisableBranchMiniEntity>(this, dataDto)
}
}